import React, { useEffect } from "react";
import './mJourney.scss';
import { forZero } from "./gloFunc";

function MJourney (props) {
  let timeArray = [];

  useEffect(() => {
  }, [props.journey]);

  for (let i = 0; i < 24; i++) {
    timeArray.push({
      name: `${forZero(i)}:00`,
    })
  }


  return (<div className="mjourney">
    <div>{`${props.year}-${props.month}-${props.day}`}</div>
    <div className="timeBlock">
    {
      timeArray.map(d => {
        return <div className="time" key={d.name}>
          {d.name}
        </div>
      })
    }
    {
      props.journey && props.journey.length ? 
      props.journey.map(d => {
        let sd = d.startHour.split(':');
        let sd1 = parseInt(sd[0]);
        let sd2 = parseInt(sd[1]);
        let ed = d.endHour.split(':');
        let ed1 = parseInt(ed[0]);
        let ed2 = parseInt(ed[1]);
        let top = sd1 * 30 + sd2 * 0.5;
        let height = (ed1 - sd1) * 30 + (ed2 - sd2) * 0.5;

        return <div className="jourData" key={d.journeyID}
        style={{top: `${top}px`, height: `${height}px`}}>
          <span className="option"></span>
          {d.title}
        </div>
      }) : ''
    }
    </div>
  </div>)
}

export default MJourney;